<template>
  <section id="intro" class="intro section">
    <div ref="content" class="container">
      <h1 ref="heading">Life’s Moments</h1>
      <div class="content">
        <div class="item">
          <p>In any given lifetime, there are various milestones we all go through – whether it’s starting a career, buying a car, planning a wedding or beginning a family.</p>
          <p>At <strong>Dignity Funerals</strong>, we wanted to look at how the nation approaches these life events. Are they something which are carefully planned for and organised in advance, or last-minute moments that are barely thought about at all?</p>
          <p>Based on survey data*, our Life’s Moments project explores the UK’s approach to all manner of events, from leaving school, right through to planning a funeral.</p>
          <p>You can browse the data to find out all sorts of extra information too, such as how people tend to feel about making certain plans and the average associated cost.</p>
        </div>
        <a class="btn" v-on:click="handleClick">Explore the data</a>

        <p class="caveat">*Survey took place in 2018</p>
      </div>
    </div>
  </section>
</template>

<script>
import { TweenMax, Power1 } from 'gsap'

export default {
  name: 'Intro',
  data () {
    return {

    }
  },
  methods: {
    handleClick: function () {
      const content = this.$refs.content

      TweenMax.to(content, 0.7, {
        opacity: 0,
        y: '-=20px',
        ease: Power1.easeIn,
        onComplete: this.handleComplete
      })
    },
    handleComplete: function () {
      this.$router.push({
        name: 'Timeline'
      })
    }
  },
  mounted: function () {
    const content = this.$refs.content

    TweenMax.set(content, {
      y: '+=20px'
    })

    TweenMax.to(content, 0.7, {
      opacity: 1,
      y: 0,
      ease: Power1.easeOut,
      delay: 0.5
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

@import '../styles/core/vars.scss';
@import '../styles/core/mixins.scss';

.intro {
  text-align: center;
  color: $c-white;
  position: relative;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  @include respond-to('medium') {
    position: absolute;
  }

  @media screen and (max-height: 640px) {
    position: relative;
  }

  h1 {
    margin-bottom: 30px;
  }

  .content {
    max-width: 700px;
    margin: 0 auto;
    padding: 0 10px;
  }

  .container {
    opacity: 0;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .caveat {
    font-size: 12px;
    padding-top: 40px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Intro.vue